import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI, {Message, MessageBox} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 导入全局样式表
import './assets/css/global.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import * as echarts from "echarts";
import 'vxe-table/lib/style.css'
import i18n from './i18n/index.js';
Vue.use(VXETable);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
// 导入弹框提示组件
Vue.prototype.$message = Message;
// confirm
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype._i18n = i18n
new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
